import styled from 'styled-components';

import { Paragraph } from '../Paragraph';

export const ItemHeader = styled(Paragraph)<{ open: boolean }>`
	font-family: ${({ theme, open }) =>
		open ? theme.font.bold : theme.font.base};
`;
